export enum THEME_TYPE {
    DEFAULT = 'default',
    DARK = 'dark',
}
export interface BaseToken {
    colorPrimary?: string;
    colorText?: string;
}
export interface ThemeConfigData {
    type: string;
    token: BaseToken;
}
